(function () {
  const root    = document.querySelector('.header-livesearch');
  const form    = document.querySelector('.livesearch-form');
  const overlay = document.querySelector('.header-search-overlay');
  const btn     = document.querySelector('a.header-tools-search');

  if (!root || !form || !overlay) {
    console.warn('[search] Missing required elements (.header-livesearch, .livesearch-form, .header-search-overlay)');
  }
  if (!btn) {
    console.warn('[search] Missing toggle anchor (.header-tools-search)');
    return; // avoid .__searchBound access on null
  }

  // Initial state
  form.hidden = true;
  overlay.hidden = true;

  const mq = window.matchMedia('(max-width: 1020px)');
  const isMobile = () => mq.matches;

  const setExpanded = (expanded) => {
    btn.setAttribute('aria-expanded', String(!!expanded));
  };

  const focusInput = () => {
    const input = document.querySelector('input.aa-Input, #autocomplete-input, input[type="search"]');
    if (!input) return;
    // next frame to ensure layout/visibility
    requestAnimationFrame(() => {
      input.focus?.({ preventScroll: true });
      try { input.setSelectionRange(input.value.length, input.value.length); } catch {}
    });
  };

  const openSearch = () => {
    if (!root || !form || !overlay) return;
    root.classList.add('is-open');
    form.hidden = false;
    overlay.hidden = false;
    document.body.classList.add('no-scroll');
    setExpanded(true);
    // try RAF, fallback to timeout
    focusInput();
    setTimeout(focusInput, 150);
    console.log('[search] opened');
  };

  const closeSearch = () => {
    if (!root || !form || !overlay) return;
    root.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    setExpanded(false);
    setTimeout(() => { form.hidden = true; overlay.hidden = true; }, 200);
    console.log('[search] closed');
  };

  // Debug shortcuts
  window.__openSearch = openSearch;
  window.__closeSearch = closeSearch;

  if (btn.__searchBound) {
    console.log('[search] already attached');
    return;
  }
  btn.__searchBound = true;

  btn.addEventListener('click', (e) => {
    if (isMobile()) {
      // Mobile: let Algolia’s detached UI handle it
      e.preventDefault(); // only prevent when we handle it
      e.stopPropagation();
      console.log('[search] click mobile');
      const mbtn = document.querySelector('button.aa-DetachedSearchButton, .aa-DetachedSearchFormButton');
      if (mbtn) { mbtn.click(); return; }
      // Fallback: try focusing the input to trigger detached
      focusInput();
      return;
    }

    // Desktop: open/close our bar
    e.preventDefault(); // replace anchor navigation with our UI
    e.stopPropagation();
    console.log('[search] click desktop');
    const isOpen = root.classList.contains('is-open');
    (isOpen ? closeSearch : openSearch)();
  }, true); // capture helps beat theme handlers

  overlay.addEventListener('click', closeSearch);

  document.addEventListener('keydown', (e) => {
    const tag = (document.activeElement && document.activeElement.tagName) || '';
    const isCE = document.activeElement && document.activeElement.isContentEditable;
    if (e.key === 'Escape' && root.classList.contains('is-open')) closeSearch();
    if (e.key === '/' && !e.metaKey && !e.ctrlKey && !e.altKey) {
      if (!/INPUT|TEXTAREA|SELECT/.test(tag) && !isCE) {
        e.preventDefault();
        openSearch();
      }
    }
  });

  // Close when clear clicked
  document.addEventListener('click', (e) => {
    const cbtn = e.target.closest('button.aa-ClearButton');
    if (cbtn) closeSearch();
  });

  // Handle live resize/orientation changes
  mq.addEventListener?.('change', () => {
    // If switching to mobile while open, close our bar (to avoid double UI)
    if (isMobile() && root.classList.contains('is-open')) closeSearch();
  });
})();

document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteProductTemplate',
    function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      const { html, item, components } = templateOptions;

      // Build your URL from the hit
      const href = (() => {
        const nt = item && item.named_tags;
        if (nt && nt.canonical && nt['color-code']) {
          const base = `${window.Shopify?.routes?.root || '/'}products/${nt.canonical}`.replace(/\/$/, '');
          const qs = `?color=${encodeURIComponent(nt['color-code'])}`;
          return `${base}${qs}`;           // no trailing slash
        }
        // Fallback to Algolia’s default link but strip a trailing slash
        return (itemLink || '').replace(/\/$/, '');
      })();

      const customImageUrl = (() => {
        const hitNamedTagsImages = item?.named_tags?.['images'] ?? null;
        const pid = item?.named_tags?.["product-id"] ?? null;
        const cc = item?.named_tags?.["color-code"] ?? null
        if( hitNamedTagsImages && pid && cc ) {
          var frontImageCode = ""; 
          var imageCodes = Array.isArray(hitNamedTagsImages) ? hitNamedTagsImages : hitNamedTagsImages.split("|");
          var defaultLeadImage = "z";
          if( imageCodes.indexOf(defaultLeadImage) !== -1 ) {
            frontImageCode = defaultLeadImage;
          } else {
            frontImageCode = imageCodes[0];
          }
          frontProductImage =
            "https://s7d2.scene7.com/is/image/Journelle/" +
            pid +
            "-" +
            cc +
            "-" +
            frontImageCode +
            "?$plp$&dpr=on&bfc=on&width=125";
          return frontProductImage ?? null
        } else {
          return null;
        }
      })();

      return html`
        <a
          href="${href}"
          class="aa-ItemLink aa-ProductItem"
          onClick="${() => trackSearchAttribution(item)}"
        >
          <div class="aa-ItemContent">
            <div class="aa-ItemPicture aa-ItemPicture--loaded">
              <img
                src="${customImageUrl || algoliaShopify.helpers.renderImage(item, 125).src}"
                alt="${item.title}"
              />
            </div>
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentTitle">
                ${components.Highlight({ hit: item, attribute: 'title' })}
                <span class="algolia-variant">
                  ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
                </span>
              </div>
              <div class="aa-ItemContentPrice">
                <div class="aa-ItemContentPriceCurrent">
                  ${algoliaShopify.helpers.displayPrice(item, distinct)}
                </div>
              </div>
            </div>
          </div>
        </a>
      `;
    }
  );

  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteProductTransformResponseHits',
    function (hits) {
      return hits
        .filter((hit) => {
          const total =
            hit.locations_inventory
              ? hit.locations_inventory['11048072']
              : Number(hit.inventory_quantity || 0);
          return total > 0;
        })
        .slice(0, 6);
    }
  );
});

document.addEventListener('algolia.autocomplete.afterInit', function() {
  algoliaShopify.config.products_autocomplete_hits_per_page = 10;
});